module.exports = __webpack_public_path__ + "static/img/MigrationInProgress.911b41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MigrationInProgress.png
// module id = aPkc
// module chunks = 1